/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Online_Cmp_CoreInputs */

const en_pc_online_cmp_core = /** @type {(inputs: Pc_Online_Cmp_CoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viewing, search, comments, forms, organizing, combining and splitting`)
};

const zh_pc_online_cmp_core = /** @type {(inputs: Pc_Online_Cmp_CoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看、搜索、批注、表单、整理、合并与拆分`)
};

/**
* | output |
* | --- |
* | "Viewing, search, comments, forms, organizing, combining and splitting" |
*
* @param {Pc_Online_Cmp_CoreInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_online_cmp_core = /** @type {((inputs?: Pc_Online_Cmp_CoreInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Online_Cmp_CoreInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_online_cmp_core(inputs)
	return zh_pc_online_cmp_core(inputs)
});
export { pc_online_cmp_core as "pc.online.cmp.core" }